// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___1hoFo","picture":"styles__picture___2mQUR","name":"styles__name___2zb99","organization":"styles__organization___-ImRm","follow":"styles__follow___Grx4S"};